"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let MultilineNotes = class MultilineNotes extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    beginEdit(...args) {
        if (!this.isEditing) {
            this.isEditing = true;
            this.valueSnapshot = this.textValue;
        }
        this.isMouseOver = false;
    }
    cancelEdit(...args) {
        if (this.isEditing) {
            this.isEditing = false;
            this.textValue = this.valueSnapshot;
        }
        this.isMouseOver = false;
    }
    save(...args) {
        try {
            this.saving = true;
            this.$emit('save', {
                value: {
                    text: this.textValue
                }
            });
            this.isEditing = false;
        }
        finally {
            this.saving = false;
        }
    }
    value;
    onValue(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("value");
    }
    editable;
    onEditable(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("editable");
    }
    isEditing;
    isMouseOver;
    selected;
    clicked;
    textValue;
    async $$load_textValue() {
        return this.value && this.value.text ? this.value.text : this.value;
    }
    saving;
    valueSnapshot;
    ux;
    dataMembers = ['isEditing', 'isMouseOver', 'selected', 'clicked', 'textValue', 'saving', 'valueSnapshot', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                isEditing: false,
                isMouseOver: false,
                selected: false,
                clicked: false,
                textValue: null,
                saving: false,
                valueSnapshot: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_script_3938_getActionArgs_value($event) {
        this.beginEdit();
    }
    async act_2248226175642056_script_3938_getActionArgs($event) {
        return {
            value: () => this.act_2248226175642056_script_3938_getActionArgs_value($event),
        };
    }
    async evh_2248226175642056_dblclick(event, scope) {
        return await this.actions.evh_2248226175642056_dblclick.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_3940_getActionArgs($event) {
        return {
            path: "isMouseOver",
            value: true,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_mouseover(event, scope) {
        return await this.actions.evh_2248226175642056_mouseover.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_3942_getActionArgs($event) {
        return {
            path: "isMouseOver",
            value: false,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_mouseleave(event, scope) {
        return await this.actions.evh_2248226175642056_mouseleave.executeFromDOM(this, event, scope);
    }
    async act_1468474219929533_script_3944_getActionArgs_value($event) {
        this.save();
    }
    async act_1468474219929533_script_3944_getActionArgs($event) {
        return {
            value: () => this.act_1468474219929533_script_3944_getActionArgs_value($event),
        };
    }
    async evh_1468474219929533_click(event, scope) {
        return await this.actions.evh_1468474219929533_click.executeFromDOM(this, event, scope);
    }
    async act_3601807637515735_script_3946_getActionArgs_value($event) {
        this.cancelEdit();
    }
    async act_3601807637515735_script_3946_getActionArgs($event) {
        return {
            value: () => this.act_3601807637515735_script_3946_getActionArgs_value($event),
        };
    }
    async evh_3601807637515735_click(event, scope) {
        return await this.actions.evh_3601807637515735_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_3936 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_3935 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_3936,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_3935],
        });
        const act_2248226175642056_script_3938 = new core_1.actions.ScriptAction({
            actionArgs: this.act_2248226175642056_script_3938_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_dblclick_3937 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_script_3938,
            event: "dblclick",
            displayName: "script",
        });
        const evh_2248226175642056_dblclick = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_dblclick_3937],
        });
        const act_2248226175642056_setData_3940 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_3940_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_mouseover_3939 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_3940,
            event: "mouseover",
            displayName: "setData",
        });
        const evh_2248226175642056_mouseover = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_mouseover_3939],
        });
        const act_2248226175642056_setData_3942 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_3942_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_mouseleave_3941 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_3942,
            event: "mouseleave",
            displayName: "setData",
        });
        const evh_2248226175642056_mouseleave = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_mouseleave_3941],
        });
        const act_1468474219929533_script_3944 = new core_1.actions.ScriptAction({
            actionArgs: this.act_1468474219929533_script_3944_getActionArgs,
            events: [],
        });
        const evh_1468474219929533_click_3943 = new core_1.actions.EventHandlerImpl({
            action: act_1468474219929533_script_3944,
            event: "click",
            displayName: "script",
        });
        const evh_1468474219929533_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1468474219929533_click_3943],
        });
        const act_3601807637515735_script_3946 = new core_1.actions.ScriptAction({
            actionArgs: this.act_3601807637515735_script_3946_getActionArgs,
            events: [],
        });
        const evh_3601807637515735_click_3945 = new core_1.actions.EventHandlerImpl({
            action: act_3601807637515735_script_3946,
            event: "click",
            displayName: "script",
        });
        const evh_3601807637515735_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_3601807637515735_click_3945],
        });
        return {
            act_7315092382398562_reloadComponentData_3936,
            evh_7315092382398562_reload_3935,
            evh_7315092382398562_reload,
            act_2248226175642056_script_3938,
            evh_2248226175642056_dblclick_3937,
            evh_2248226175642056_dblclick,
            act_2248226175642056_setData_3940,
            evh_2248226175642056_mouseover_3939,
            evh_2248226175642056_mouseover,
            act_2248226175642056_setData_3942,
            evh_2248226175642056_mouseleave_3941,
            evh_2248226175642056_mouseleave,
            act_1468474219929533_script_3944,
            evh_1468474219929533_click_3943,
            evh_1468474219929533_click,
            act_3601807637515735_script_3946,
            evh_3601807637515735_click_3945,
            evh_3601807637515735_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
    }),
    __metadata("design:type", Object)
], MultilineNotes.prototype, "value", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MultilineNotes.prototype, "onValue", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: Boolean,
    }),
    __metadata("design:type", Boolean)
], MultilineNotes.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('editable'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], MultilineNotes.prototype, "onEditable", null);
MultilineNotes = __decorate([
    (0, vue_property_decorator_1.Component)()
], MultilineNotes);
exports.default = MultilineNotes;
vue_property_decorator_1.Vue.component("MultilineNotes", MultilineNotes);
